import { useFloating, useClick, useDismiss, useInteractions, useRole, useTransitionStyles, offset, flip, shift } from "@floating-ui/react";
import { useState, ReactNode } from "react";
import { Nav } from "react-bootstrap";
import { EnhancedButton } from "../buttons/EnhancedButton";
import { usePageContext } from "vike-react/usePageContext";

export function NavCollapse({
	collapsed,
	children,
}: {
	collapsed: boolean;
	children: ReactNode; // just <Nav.Link> items
}) {
	const [open, setOpen] = useState(false);
  	const { urlPathname } = usePageContext();

	const { refs, context } = useFloating({
		open,
		onOpenChange: setOpen,
		placement: "bottom-start",
		middleware: [
			offset(4), // margin between button & dropdown
			flip(), // flip if it would overflow the viewport
			shift({ padding: 8 }), // keep at least 8px from edges
		],
	});

	const click = useClick(context);
	const dismiss = useDismiss(context);
	const role = useRole(context, { role: "menu" });
	const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);

	const { isMounted, styles } = useTransitionStyles(context, {
		duration: 150,
	});

	if (!collapsed) {
		// ✅ Full horizontal menu
		return (
			<Nav activeKey={urlPathname} className="navbar-nav d-flex gap-3 align-items-center">
				{children}
			</Nav>
		);
	}

	// ✅ Collapsed menu
	return (
		<div className="position-relative">
			<EnhancedButton ref={refs.setReference} {...getReferenceProps()} variant="outline-primary">
				Menu
			</EnhancedButton>

			{isMounted && (
				<div ref={refs.setFloating} {...getFloatingProps()} style={styles} className="dropdown-menu show p-0" onClick={() => setOpen(false)}>
					<Nav activeKey={urlPathname} className="flex-column">
						{children}
					</Nav>
				</div>
			)}
		</div>
	);
}
